// extracted by mini-css-extract-plugin
module.exports = {"container":"CBMaterialBalance_container__2zh7x","balanceObject":"CBMaterialBalance_balanceObject__2Qqfc","inactive":"CBMaterialBalance_inactive__2ODUl"};